const plog = {
  _log(type, message, data = null) {
    if (window.debug === false) return;

    const styles = {
      info: {
        background: "#e0f7fa",
        color: "#006064",
        fontSize: "14px",
        prefix: "[INFO]",
      },
      warning: {
        background: "#fff3e0",
        color: "#e65100",
        fontSize: "16px",
        prefix: "[WARNING]",
      },
      error: {
        background: "#ffebee",
        color: "#b71c1c",
        fontSize: "18px",
        prefix: "[ERROR]",
      },
      success: {
        background: "#e8f5e9",
        color: "#2e7d32",
        fontSize: "14px",
        prefix: "[SUCCESS]",
      },
    };

    const logStyle = styles[type] || styles.info;

    const styleString = `
            background: ${logStyle.background};
            color: ${logStyle.color};
            font-size: ${logStyle.fontSize};
            padding: 4px 8px;
            border-radius: 4px;
            font-weight: bold;
        `;

    const timestamp = new Date().toLocaleTimeString();
    const logMessage = `%c${logStyle.prefix} ${timestamp} | ${message}`;

    switch (type) {
      case "error":
        console.error(logMessage, styleString, data || "");
        break;
      case "warning":
        console.warn(logMessage, styleString, data || "");
        break;
      default:
        console.log(logMessage, styleString, data || "");
        break;
    }
  },

  info(message, data = null) {
    this._log("info", message, data);
  },
  warning(message, data = null) {
    this._log("warning", message, data);
  },
  error(message, data = null) {
    this._log("error", message, data);
  },
  success(message, data = null) {
    this._log("success", message, data);
  },
};
